import { Component, OnInit } from '@angular/core';
import { UIStateService } from '../ui-state.service';

@Component({
  selector: 'mea-profession',
  templateUrl: './profession.component.html',
  styleUrls: ['./profession.component.css']
})
export class ProfessionComponent implements OnInit {

  static profession(hierarchy) {
    const profession = hierarchy.substr(0, 2);

    const PROFESSIONS = {
      '03': { name: 'מתמטיקה', hierarchy: '03' },
      '05': { name: 'אנגלית', hierarchy: '05' },
      '07': { name: 'מדעים', hierarchy: '07' },
      '01': { name: 'לשון', hierarchy: '01' },
      '06': { name: 'היסטוריה', hierarchy: '06' },
      '04': { name: 'תנך', hierarchy: '04' },
      '02': { name: 'אזרחות', hierarchy: '02' },
    };

    return PROFESSIONS[profession];
  }

  constructor(private uiState: UIStateService) { }

  ngOnInit() {
    this.uiState.setSubjectList([
      { name: '', hierarchy: '' },
      { name: '', hierarchy: '' },
      { name: 'בחרו מקצוע', hierarchy: '' },
    ]);
    this.uiState.setActivity('_');
  }

}
